import React, { useEffect, useState, useRef } from 'react';
import api from '../../api';
import TrainCard from '../card/TrainCard';
import Treno from '../../assets/icone/card/treniColore.svg';
import CategoryCarousel from '../../components/utils/CategoryCarousel';
import { useTranslation } from 'react-i18next';

const TrainCarousel = () => {
  const [tickets, setTickets] = useState([]);
  const { t } = useTranslation();
  const didFetch = useRef(false);

  useEffect(() => {
    if (didFetch.current) return; // Se già eseguito, esce
    didFetch.current = true;

    const fetchTrains = async () => {
      try {
        const response = await api.get('/reservations/trains/active');
        setTickets(response.data.activeItems);
      } catch (error) {
      }
    };

    fetchTrains();
  }, []);

  const renderTrainCard = (ticket) => (
    <TrainCard ticket={ticket} user={ticket.user_id} />
  );

  return (
    <CategoryCarousel
      items={tickets}
      categoryIcon={Treno}
      categoryTitle={t('travel.trainReservation')}
      renderCard={renderTrainCard}
      category="trains"
    />
  );
};

export default TrainCarousel;
